import { computed, effect, Injectable, signal } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { interval, Observable } from 'rxjs';
import { RoleService } from "./roles.service";
import { toSignal } from "@angular/core/rxjs-interop";
import { AppApis } from "@app/core/APIs/app-apis";
import { AppAngularBaseClass } from "@app/core/services/app-angular-base";
import { AllUserRoles } from "@app/enum/enumLookup";

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};

const skipLoading = {
  headers: new HttpHeaders({
    "skip-loading-interceptor": "yes",
  }),
};


@Injectable({ providedIn: 'root' })
export class ParticipantAlertsService extends AppAngularBaseClass {

  partId: number = 0;
  alertsEnabled = false;
  hasRoles = false;

  //public showAlerts = computed(() => this.roleService.hasAnyRole(ParticipantAlertsService.alertRoles) && this.roleService.isFeatureEnabled('ALERTS') )

  static readonly alertRoles: string[] = [
    AllUserRoles.HOP,
    AllUserRoles.FADADMIN,
    AllUserRoles.FADPSYCH,
    AllUserRoles.FADSRPSYCH,
    AllUserRoles.FADCHPSYCH,
    AllUserRoles.IRSD_INV,
    AllUserRoles.LGL_INV_RV,
    AllUserRoles.LGL_INVES
  ];

  /**
   * Used to compare the old value with the new value
   */
  private priorUnreadCount: number = 0;

  newAlertsMessage = computed(() => {
      const unreadCount = this.unreadCount();
      const diff = unreadCount - this.priorUnreadCount;

      this.priorUnreadCount = unreadCount;

      return diff > 0 ? `You have ${diff} new alert(s)` : "";
  });

  readonly showAlerts = computed(() =>
    (this.user.partId() || 0) > 0 &&
    this.roleService.hasAnyRole(ParticipantAlertsService.alertRoles) &&
    this.roleService.isFeatureEnabled('ALERTS')
  );

  readonly refreshTrigger = signal(0); // manual bump signal
  public readonly unreadCount = signal<number>(0); // exposed signal
  public readonly totalCount = signal<number>(0); // exposed signal

  unreadEndpoint: string = "";
  totalEndpoint: string = "";

  readonly tick = toSignal(
    interval(50_000), // emits every 50 seconds
    { initialValue: 0 }
  );

 // apis = inject(AppApis);

  constructor(
    public roleService: RoleService,
  )
  {
    super();

    // Story #25740 - turn OFF tostr
    // effect(() => {
    //   const msg = this.newAlertsMessage();
    //   if(msg) {
    //     this.toastrService.info('', msg, { positionClass: 'toast-top-center'});  // KMW: Moved to top center cuz top-left interferes with me clicking the menu
    //   }
    // });

    effect(() => {
      if (!this.showAlerts()) return;
      const partId = this.user.partId()!;

      this.unreadEndpoint = this.apis.core.getAlertParticipantByPartIdUnreadCount(partId);
      this.totalEndpoint = this.apis.core.getAlertParticipantByPartIdTotalCount(partId);

      // Fire this periodically
      this.tick();

      // Fire this manually by calling .reloadCounts
      this.refreshTrigger();

      this.http.get<number>(this.unreadEndpoint, skipLoading)
        .pipe(this.takeUntilDestroyed())
        .subscribe({
          next: count => this.unreadCount.set(count),
          error: () => this.unreadCount.set(0),
        });

      this.http.get<number>(this.totalEndpoint, skipLoading)
        .pipe(this.takeUntilDestroyed())
        .subscribe({
          next: count => this.totalCount.set(count),
          error: () => this.totalCount.set(0),
        });
    });
  }



  public reloadCounts()
  {
    this.refreshTrigger.set(new Date().getTime());
  }

  // TODO: Remove dependency on passing the partId. The server already knows it.
  // TODO: Convert to crudServices and apis endpoints
  public markRead(
    partId: number,
    alertParticipantId: number,
  ): Observable<number> {
    return this.http.get<number>(
      //`${this.api.bitsCore}/Alert/Participant/${partId}/Acknowledge/${alertParticipantId}`,
      this.apis.core.getAlertParticipantByPartIdAcknowledgeByAlertParticipantId(alertParticipantId, partId.toString()),
    );
  }

  // TODO: Remove dependency on passing the partId. The server already knows it.
  public markAllRead(partId: number): Observable<number> {
    return this.http.post<number>(
      //`${this.api.bitsCore}/Alert/Participant/${partId}/Acknowledge/All`,
      this.apis.core.postAlertParticipantByPartIdAcknowledgeAll(partId),
      httpOptions,
    );
  }
}
